import { envs } from '../configuration/env.js';

// Users API
export const USERS_BASE_URL = `${envs.baseUrl}/api/Users`;
export const GET_MY_PROFILE_URL = `${USERS_BASE_URL}/Me`;
export const POPUP_PREFERENCES_URL = `${USERS_BASE_URL}/PopupPreference`;
export const EVENT_USERS_URL = `${USERS_BASE_URL}/ForEvent`;
export const GET_REQUESTERS = `${USERS_BASE_URL}/Requesters`;
export const FAMILY_USERS = `${USERS_BASE_URL}/Family`;
export const GET_ADMIN_USERS = `${USERS_BASE_URL}/Admins`;
export const MLT_USERS = `${USERS_BASE_URL}/MLTs`;
export const EVENT_ALL_ACTIVE_USERS_URL = `${USERS_BASE_URL}/ActiveUsers`;
export const GET_USER_FILTER = `${USERS_BASE_URL}/GetUserFilterString`;
export const SET_USER_FILTER = `${USERS_BASE_URL}/SetUserFilterString`;

// Notifications API
export const GET_NOTIFICATIONS = `${envs.baseUrl}/api/Notifications`;
export const GET_VCS_FILE = `${GET_NOTIFICATIONS}/VCS`;
export const MARK_AS_READ = `${GET_NOTIFICATIONS}/MarkAsRead`;

// Events API
export const EVENTS_BASE_URL = `${envs.baseUrl}/api/Events`;
export const EVENTS_SUBMIT_LIGHT = `${envs.baseUrl}/api/Events/SubmitLight`;
export const GET_ALL_EVENT = `${EVENTS_BASE_URL}`;
export const GET_ALL_EVENT_BY_FAMILY = `${EVENTS_BASE_URL}/ByFamily`;
export const GET_ALL_EVENT_BY_FAMILY_SUGGESTED = `${EVENTS_BASE_URL}/ByFamilySuggested`;
export const GET_MY_EVENTS = `${EVENTS_BASE_URL}/Mine`;
export const EVENT_DETAILS_FILTER_URL = `${EVENTS_BASE_URL}/Filtered`;
export const FUTURE_EVENTS = `${EVENTS_BASE_URL}/Future`;
export const EVENTS_FOR_MLT = `${EVENTS_BASE_URL}/ForMLT`;
export const GUEST_MLT = `MLTGuests`;
export const GUEST_ADMIN = `AdminGuests`;
export const EVENT_KEY_INFO = `KeyInfo`;
export const EVENT_COVER_URL = `${EVENTS_BASE_URL}/Cover`;
export const EVENT_BRIEFS_URL = `${EVENTS_BASE_URL}/Briefs`;
export const DOWNLOAD_BRIEF_URL = `${EVENT_BRIEFS_URL}/Download`;
export const EVENT_ATTACHMENTS_URL = `${EVENTS_BASE_URL}/Attachments`;
export const DOWNLOAD_ATTACHMENTS_URL = `${EVENT_ATTACHMENTS_URL}/Download`;
export const EVENT_IMAGES_URL = `${EVENTS_BASE_URL}/Images`;
export const DOWNLOAD_IMAGES_URL = `${EVENT_IMAGES_URL}/Download`;
export const EVENT_VIDEOS_URL = `${EVENTS_BASE_URL}/Videos`;
export const EVENT_SEGMENTS_URL = `${EVENTS_BASE_URL}/Segments`;
export const EVENT_FEEDBACKS_URL = `${EVENTS_BASE_URL}/Feedbacks`;
export const ALL_FEEDBACKS_URL = `${EVENTS_BASE_URL}/AllFeedbacks`;
export const UPDATE_NONEDIT_URL = `${EVENTS_BASE_URL}/SetAsEditable`;
export const SEND_VALIDATION_URL = `${EVENTS_BASE_URL}/SendForValidation`;
export const REJECT_REQUEST = `${EVENTS_BASE_URL}/Reject`;
export const SEND_TO_REQUESTOR = `${EVENTS_BASE_URL}/SendToRequestor`;
export const VALIDATE_OPEN_EVENT = `${EVENTS_BASE_URL}/ValidateAndOpen`;
export const PROCESS_INVITATION = `${EVENTS_BASE_URL}/ProcessInvitation`;
export const PROCESS_MLT_INVITATION = `${EVENTS_BASE_URL}/ProcessMLTInvitation`;
export const MARK_AS_COMPLETE = `${EVENTS_BASE_URL}/MarkAsComplete`;
export const CANCEL_EVENT = `${EVENTS_BASE_URL}/Cancel`;
export const ADD_USERS = `${EVENTS_BASE_URL}/AddGuest`;
export const REMOVE_USERS = `${EVENTS_BASE_URL}/RemoveGuest`;
export const ADD_MLT_USERS = `${EVENTS_BASE_URL}/AddMLTGuest`;
export const REMOVE_MLT_USERS = `${EVENTS_BASE_URL}/RemoveMLTGuest`;
export const EVENT_VISIBLE_TO_USER = `${EVENTS_BASE_URL}/isVisibleToUser`;
export const EVENT_NEW_MEDIA_NOTIF = `${EVENTS_BASE_URL}/SendNewMediaNotification`;
export const EVENT_CHANGE_REQUESTOR = `${EVENTS_BASE_URL}/ChangeRequestor`;


// Sites API
export const SITES_BASE_URL = `${envs.baseUrl}/api/Sites`;
export const SITE_DETAILS_URL = `${SITES_BASE_URL}`;
export const GET_SITECODES = `${SITES_BASE_URL}/Codes`;
export const SITE_MANAGEMENT_DETAILS = `${SITES_BASE_URL}/ManagementDetails`;
export const GET_REGIONS = `${SITES_BASE_URL}/Regions`;
export const GET_SITETYPES = `${SITES_BASE_URL}/SiteTypes`;

// EmailTemplates API
export const EMAIL_TEMPLATES_BASE_URL = `${envs.baseUrl}/api/EmailTemplates`;

// Geo API
const GEO_BASE_URL = `${envs.baseUrl}/api/Geo`;
export const COUNTRY_CODE_URL = `${GEO_BASE_URL}/CountryCodes`;
export const COUNTRY_URL = `${GEO_BASE_URL}/Countries`;
export const STATE_URL = `${GEO_BASE_URL}/States`;
export const CITY_URL = `${GEO_BASE_URL}/Cities`;

// Accounts API
export const POST_LOGIN = `${envs.baseUrl}/api/Accounts/Login`;

// AuditLogs API
export const GET_HISTORY_URL = `${envs.baseUrl}/api/AuditLogs`;
export const ADD_COMMENTS_URL = `${envs.baseUrl}/api/AuditLogs/AddComments`;

// Dashboards API
const DASHBOARDS_BASE_URL = `${envs.baseUrl}/api/Dashboards`;
export const SITE_EVENT_DETAILS_UPDATED = `${DASHBOARDS_BASE_URL}/SiteEventDetailsUpdated`;
export const MILESTONE_DATA = `${DASHBOARDS_BASE_URL}/MilestoneData`;
export const EVENT_DETAILS_BY_AFTER_VISIT = `${DASHBOARDS_BASE_URL}/EventDetailsByAfterVisit`;
export const EVENT_DETAILS_DASHBOARD = `${DASHBOARDS_BASE_URL}/EventDetails`;
export const EVENT_DETAILS_BY_ASSOCIATE = `${DASHBOARDS_BASE_URL}/EventDetailsByAssociate`;
export const EVENT_DETAILS_BY_COUNTRY = `${DASHBOARDS_BASE_URL}/EventDetailsByCountry`;
export const SITE_ANNIVERSARY = `${DASHBOARDS_BASE_URL}/SiteAnniversary`;
export const EVENT_CHART_FAMILY_URL = `${DASHBOARDS_BASE_URL}/EventsByFamilyMember`;
export const EVENT_CHART_STATUS_URL = `${DASHBOARDS_BASE_URL}/EventsByStatus`;
export const EVENT_CHART_YEAR_URL = `${DASHBOARDS_BASE_URL}/EventsByYear`;
export const EVENT_CHART_VISITS_URL = `${DASHBOARDS_BASE_URL}/EventsByMostVisited`;
export const EVENT_TYPE_DONUT_URL = `${DASHBOARDS_BASE_URL}/EventsByType`;
export const TOUCHES_CHART_FAMILY_URL = `${DASHBOARDS_BASE_URL}/TouchesByFamilyMember`;
export const TOUCHES_CHART_SITES_URL = `${DASHBOARDS_BASE_URL}/TouchesBySites`;
export const TOUCHES_CHART_YEAR_URL = `${DASHBOARDS_BASE_URL}/TouchesByYear`;
export const TOUCHES_DETAILS_FILTER_URL = `${DASHBOARDS_BASE_URL}/TouchesReport`;
export const TOUCHES_SEGMENT_DONUT_URL = `${DASHBOARDS_BASE_URL}/FilteredTouches`;

// Other types API (static data)
export const APP_SETTINGS = `${envs.baseUrl}/api/AppSettings`;
export const EVENT_TYPE_URL = `${envs.baseUrl}/api/EventTypes`;
export const EVENT_FORMAT_URL = `${envs.baseUrl}/api/EventFormats`;
export const EVENT_LAST_VISIT_URL = `${envs.baseUrl}/api/TimeIntervals`;
export const EVENT_ASSOCIATE_URL = `${envs.baseUrl}/api/EventAssociates`;
export const EVENT_STATUS_URL = `${envs.baseUrl}/api/EventStatus`;
export const USER_TYPES_URL = `${envs.baseUrl}/api/UserTypes`;
export const EVENT_SURVEY_QUESTIONS = `${envs.baseUrl}/api/EventSurveyQuestions`;

